import { fromJS } from 'immutable';
export var SET_EVENT_TYPE_LIST = 'event-management/SET_EVENT_TYPE_LIST';
export var SET_NEW_EVENT_DATA = 'event-management/SET_NEW_EVENT_DATA';
export var SET_EVENT_DRAFT_DATA = 'event-management/SET_EVENT_DRAFT_DATA';
export var SET_EVENT_PUBLISHED_DATA = 'event-management/SET_EVENT_PUBLISHED_DATA';
export var SET_NEW_EVENT_SORT = 'event-management/SET_NEW_EVENT_SORT';
export var SET_EVENT_DRAFT_SORT = 'event-management/SET_EVENT_DRAFT_SORT';
export var SET_PUBLISHED_SORT = 'event-management/SET_PUBLISHED_SORT';
export var SET_DIALOG_MODE = 'event-management/SET_DIALOG_MODE';
export var SET_DIALOG_EVENT_DRAFT_DATA = 'event-management/SET_DIALOG_EVENT_DRAFT_DATA';
export var SET_DIALOG_EVENT_TYPE_DATA = 'event-management/SET_DIALOG_EVENT_TYPE_DATA';
export var SET_DIALOG_INFO = 'event-management/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'event-management/CLEAR_DIALOG_INFO';
export var setEventTypeList = function setEventTypeList(data) {
  return {
    type: SET_EVENT_TYPE_LIST,
    data: data
  };
};
export var setNewEventData = function setNewEventData(data) {
  return {
    type: SET_NEW_EVENT_DATA,
    data: data
  };
};
export var setEventDraftData = function setEventDraftData(data) {
  return {
    type: SET_EVENT_DRAFT_DATA,
    data: data
  };
};
export var setEventPublishedData = function setEventPublishedData(data) {
  return {
    type: SET_EVENT_PUBLISHED_DATA,
    data: data
  };
};
export var setNewEventSort = function setNewEventSort(sort) {
  return {
    type: SET_NEW_EVENT_SORT,
    sort: sort
  };
};
export var setEventDraftSort = function setEventDraftSort(sort) {
  return {
    type: SET_EVENT_DRAFT_SORT,
    sort: sort
  };
};
export var setPublishedSort = function setPublishedSort(sort) {
  return {
    type: SET_PUBLISHED_SORT,
    sort: sort
  };
};
export var setDialogMode = function setDialogMode(data) {
  return {
    type: SET_DIALOG_MODE,
    data: data
  };
};
export var setDialogEventDraftData = function setDialogEventDraftData(data) {
  return {
    type: SET_DIALOG_EVENT_DRAFT_DATA,
    data: data
  };
};
export var setDialogEventTypeData = function setDialogEventTypeData(data) {
  return {
    type: SET_DIALOG_EVENT_TYPE_DATA,
    data: data
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo() {
  return {
    type: CLEAR_DIALOG_INFO
  };
};
var initDialogInfo = {
  // mode: user.create, user.edit, rights.create, rights.edit
  mode: '',
  data: {}
};
var initialState = fromJS({
  eventTypeList: [],
  newEventData: [],
  eventDraftData: [],
  eventPublishedData: [],
  // table sort
  newEventSort: {
    field: 'beginTime',
    desc: true
  },
  eventDraftSort: {
    field: 'beginTime',
    desc: true
  },
  publishedSort: {
    field: 'beginTime',
    desc: true
  },
  // dialog mode: eventDraft.create, eventDraft.edit, eventType.edit
  dialogMode: '',
  dialogEventDraftData: {
    eventType: '',
    description: '',
    place: '',
    position: {
      lat: '',
      lng: ''
    }
  },
  dialogInfo: initDialogInfo,
  dialogEventTypeData: {}
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_EVENT_TYPE_LIST:
      return state.set('eventTypeList', fromJS(action.data));

    case SET_NEW_EVENT_DATA:
      return state.set('newEventData', fromJS(action.data));

    case SET_EVENT_DRAFT_DATA:
      return state.set('eventDraftData', fromJS(action.data));

    case SET_EVENT_PUBLISHED_DATA:
      return state.set('eventPublishedData', fromJS(action.data));

    case SET_NEW_EVENT_SORT:
      return state.set('newEventSort', fromJS(action.sort));

    case SET_EVENT_DRAFT_SORT:
      return state.set('eventDraftSort', fromJS(action.sort));

    case SET_PUBLISHED_SORT:
      return state.set('publishedSort', fromJS(action.sort));

    case SET_DIALOG_MODE:
      return state.set('dialogMode', fromJS(action.data));

    case SET_DIALOG_EVENT_DRAFT_DATA:
      return state.set('dialogEventDraftData', fromJS(action.data));

    case SET_DIALOG_EVENT_TYPE_DATA:
      return state.set('dialogEventTypeData', fromJS(action.data));

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(action.data));

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(initDialogInfo));

    default:
      return state;
  }
}